import React from "react";
// react component used to create sweet alerts
import SweetAlert from "react-bootstrap-sweetalert";



// core components

import LinearProgress from '@material-ui/core/LinearProgress';

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";


import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";

class Progress extends React.Component{
    render(){
        const {title,value}=this.props
        return  <SweetAlert
            style={{ display: "block", marginTop: "-100px" }}
            title={title}
            onConfirm={()=>1}
            showConfirm={false}
        >
            Progress<br/>
            <LinearProgress
                value={value}
                variant='determinate'
            />
        </SweetAlert>
    }
}
export default withStyles(sweetAlertStyle)(Progress);



// WEBPACK FOOTER //
// ./src/components/Alert/Progress.jsx